
































import VueOptions from '@utils/VueOptions'
import routes from '@utils/VueOptions'
import WizardRoutes from '@ui/AudienceSetWizard/routes'

settings =
  name: 'PartnershipSteps'

  vue:
    props: ['wizard']

    computed:
      partnershipSteps: ->
        WizardRoutes.find((item) -> item.name is 'partnership').steps
      
      currentStepName: ->
        @$route.query.step

      alerts: ->
        'partnership-special-terms': [
          { type: 'error', message: '<a href="#" class="text-recess underline">Item Distribution</a> does not have a title' },
          { type: 'error', message: 'Define a <a href="#" class="text-recess underline">Listing Type</a>' },
          { type: 'warning', message: '<a href="#" class="text-recess underline">The Stadium</a> venue does not have a photo' },
          { type: 'warning', message: 'You have not selected <a href="#" class="text-recess underline">Storage Facilities</a>' },
          { type: 'warning', message: 'Missing <a href="#" class="text-recess underline">Audience Demographics</a>' },
        ]

    methods:
      hiNavToStep: (stepName) ->
        @wizard.navToStepName stepName

      alertsForStep: (stepName) -> @alerts[stepName] || []
      stepHasAlerts: (stepName) -> @alertsForStep(stepName).length > 0

export default VueOptions.vue settings
